/*
 * Reading-page behavior for the content pages (articles / how-to / news):
 * builds the "On this page" contents from the headings in .content-prose,
 * highlights the current section on scroll, and wires the copy-link button.
 * No-op on pages without a .content-prose block.
 *
 * Content is editor-authored, so the top heading level varies - use the
 * highest level (h2, then h3, then h4) that occurs at least twice.
 */
(function () {
    var prose = document.querySelector('.content-prose');
    var tocBox = document.querySelector('[data-content-toc]');
    if (prose && tocBox) {
        var headings = [];
        ['h2', 'h3', 'h4'].some(function (level) {
            var found = prose.querySelectorAll(level);
            if (found.length >= 2) { headings = found; return true; }
        });
        if (headings.length) {
            var nav = tocBox.querySelector('.content-toc');
            headings.forEach(function (h, i) {
                if (!h.id) h.id = 'section-' + (i + 1);
                var a = document.createElement('a');
                a.href = '#' + h.id;
                a.textContent = h.textContent;
                nav.appendChild(a);
            });
            tocBox.hidden = false;
            var links = nav.querySelectorAll('a');
            var spy = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    links.forEach(function (link) {
                        link.classList.toggle('active', link.getAttribute('href') === '#' + entry.target.id);
                    });
                });
            }, {rootMargin: '-80px 0px -70% 0px'});
            headings.forEach(function (h) { spy.observe(h); });
        }
    }
    var copy = document.querySelector('[data-content-copy]');
    if (copy && navigator.clipboard) {
        copy.addEventListener('click', function () {
            navigator.clipboard.writeText(location.href).then(function () {
                var icon = copy.querySelector('i');
                icon.className = 'icon-check';
                setTimeout(function () { icon.className = 'icon-link'; }, 1500);
            });
        });
    }
})();
